export const dateFormat = "YYYY-MM-DD";

export const dateTimeFormat = "YYYY-MM-DD HH:mm";

export const dateTimeFormatAMPM = "DD-MMM-YYYY hh:mm A";

export const dateTimeFormatAMPMSlash = "DD/MMM/YYYY hh:mm A";

export const dateFormatUI = "DD/MMM/YYYY";

export const timeFormatAMPM = "hh:mm:ss A";

export const timeFormathhmmAMPM = "hh:mm A";